import React from "react";
import favIcon from "../../assets/images/svg/favIcon.svg";
function Footer() {
  return (
    <footer className="w-100 h-12 bg-dark">
      <div className=" d-flex align-items-center justify-content-center h-full px-4 py-2">
        <div className="d-flex align-items-center gap-3">
          <img alt="Logo" src={favIcon} />

          <div className="text-white text-white font-16 poppins-light pb-0 m-0">
            Powered by Geesez© Copyright 2025. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
